import WResultsHealth from './WResultsHealth'

export default WResultsHealth
